import { forwardRef } from "react";
import React, { useId } from "react";
function SvgThinArrow({ title, titleId, ...props }, ref) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={50}
      height={30}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="currentColor"
        d="M33.857.586a2 2 0 0 1 2.83 0l12.727 12.728a2 2 0 0 1 0 2.828L36.687 28.871a2.001 2.001 0 0 1-2.83-2.83l9.315-9.313H2a2 2 0 1 1 0-4h41.172l-9.315-9.313a2.001 2.001 0 0 1 0-2.83Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgThinArrow);
export default ForwardRef;
